import styled from 'styled-components';

export const Container = styled.div<{ isDraggingOver: boolean }>`
  background-color: ${(props) =>
    props.isDraggingOver ? props.theme.globalColors.deepPurple : props.theme.globalColors.deepPurple};
`;
